export const AIRDROP_BOT_USER_ID = import.meta.env.OC_AIRDROP_BOT_CANISTER;
